__turbopack_context__.v({
  "SoftwareCardList__Container": "KIYEYW_SoftwareCardList__Container",
  "SoftwareCardList__List": "KIYEYW_SoftwareCardList__List",
  "SoftwareCardList__Row": "KIYEYW_SoftwareCardList__Row",
  "SoftwareCardList__Title": "KIYEYW_SoftwareCardList__Title",
});
